<template>
  <div>
    <Loading v-if="validatingToken" />

    <v-app v-else :class="deviceClass">
      <Content />
      <Header v-if="user" />
    </v-app>
  </div>
</template>

<script>
import axios from 'axios'
import { baseApiUrl, userKey } from '@/global'
import { mapState } from 'vuex'
import Content from '@/templates/Content'
import Header from '@/templates/Header'
import Loading from '@/templates/Loading'

import deviceDetection from '@/mixins/deviceDetection'

export default {
  name: 'App',
  components: { Content, Header, Loading },
  mixins: [deviceDetection],
  computed: mapState(['user']),
  data() {
    return {
      validatingToken: true
    }
  },
  methods: {
    async validateToken() {
      this.validatingToken = true
      try {
        if (this.$route.name === 'newpassword') {
          const email = this.$route.query.email
          const token = this.$route.params.token


          try {
            const check = await axios.get(`${baseApiUrl}/resetPassword/${token}`, { e: email })
            if (check.data) {
              this.$router.push({ name: 'newpassword' })
            } else {

              this.$router.push({ name: 'auth' })
              this.$toasted.global.defaultError({ msg: `Token expirou ou é inválido!` })
            }
          } catch (err) {
            this.$toasted.global.defaultError({ msg: `${err}` })
            this.$router.push({ name: 'auth' })
          }
          this.validatingToken = false;
          return;
        }

        const json = localStorage.getItem(userKey)
        const userData = JSON.parse(json)
        this.$store.commit('setUser', null)

        if (!userData) {
          this.validatingToken = false
          this.$router.push({ name: 'auth' }).catch(() => { })
          return
        }

        const res = await axios.post(`${baseApiUrl}/validateToken`, userData)

        if (res.data) {
          this.$store.commit('setUser', userData)
        } else {
          localStorage.removeItem(userKey)
          this.$router.push({ name: 'auth' }).catch(() => { })
        }
      } catch (err) {
        console.error('Erro ao validar o token:', err);
        this.$toasted.global.defaultError({ msg: 'Erro inesperado!' });
        this.$router.push({ name: 'auth' }).catch(() => { });

      } finally {
        this.validatingToken = false
      }

    }
  },
  mounted() {
    this.validateToken()
    document.body.classList.toggle('mobile-device', this.isMobile)
  }
};
</script>
<style lang="css" scoped>
/* .body {
    background: url('@/img/sinproerp4.jpg') no-repeat center;
    background-size: cover;
    opacity: 0.1;
  } */
</style>
